module.exports = __webpack_public_path__ + "img/ce40626.jpg";